// DS6.17 - Radio button semantics
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import HeadlessRadioButton from '@wix/da-a11y/pkg/components/formControls/RadioButton';
import commonStyles from '../../common.scss';
import s from './LozengeRadioButton.scss';
/**
 * A radio button in the shape of a lozenge.
 *
 * This component has no theme, so be careful where you use it. Be sure to check contrast values
 * for accessibility compliance.
 */ const LozengeRadioButton = (_param)=>{
    var { checked, children, className: consumerProvidedClassName, selectedClassName } = _param, rest = _object_without_properties(_param, [
        "checked",
        "children",
        "className",
        "selectedClassName"
    ]);
    return /*#__PURE__*/ React.createElement(HeadlessRadioButton, _object_spread({
        checked: checked,
        className: s['headless-wrapper']
    }, rest), /*#__PURE__*/ React.createElement("div", {
        className: c(s['visible-root'], commonStyles['root'], checked && s['selected'], checked && selectedClassName, consumerProvidedClassName)
    }, children));
};
LozengeRadioButton.displayName = 'LozengeRadioButton';
export default LozengeRadioButton;

//# sourceMappingURL=LozengeRadioButton.js.map